/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/no-multi-comp */
import React, { useEffect, useState, useReducer, useCallback, useMemo, useRef, Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import {
  Alert,
  Box,
  Button,
  DialogContentText,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Stack,
  Typography,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import FilterListOutlinedIcon from '@mui/icons-material/FilterListOutlined';
import PlaylistAddCheckOutlinedIcon from '@mui/icons-material/PlaylistAddCheckOutlined';
import * as XLSX from 'xlsx';
import {
  TableV2,
  CustomFilterV2,
  UploadDialogV2,
  DialogDefaultV2,
  ButtonMenuV2,
} from '../../../components/v2';
import {
  tableV2MultilineGridSx,
} from '../../../components/v2/tableV2Styles';
import * as selectorsAuth from '../../../store/auth/reducer';
import * as selectorsFiltro from '../../../store/filtro/reducer';
import * as actionsNsirs from '../../../store/nsir/actions';
import * as actionsRelatorioJob from '../../../store/relatorioJob/actions';
import * as actionsToast from '../../../store/toast/actions';
import * as actionsLoader from '../../../store/loader/actions';
import * as actionsFiltro from '../../../store/filtro/actions';
import * as Role from '../../../constants/role';
import * as Status from '../../../constants/status';
import { isRoleAuditoriaNsir } from '../../../helpers/auditoriaNsirPermission';
import {
  NSIR_DELETE_CONFLICT,
  NSIR_DELETE_CONFLICT_FALLBACK,
  getAvisoNsirFechada,
  getConsequenciasExclusao,
  getMotivosDescricao,
} from '../../../helpers/nsirDeleteConflict';
import {
  canCloneAuditoriaFaixa,
  getNsirFiltroFixoAuditoriaNsir,
  INSPECAO_USUO_MUTUO_ID,
  isInspecaoAuditoriaFaixa,
  isUsuarioUsoMuto,
  mergeFiltroNsirComRestricoesAuditoria,
} from '../../../utils';
import {
  EquipamentoNsirCell,
  CtPlanExecCell,
  MalhaRegionalAlimentadorCell,
  TipoServicoCell,
  DatasCell,
  AreaCell,
  TextCell,
  StatusCell,
} from './components/TableCells';
import ImportValidationModal from './components/ImportValidationModal';
import ExportServicosDialog from './components/ExportServicosDialog';
import ResumoSection from './ResumoSection';
import ContextBar from './ContextBar';
import { resolveNsirListPersona, getPipelineGroupsForPersona, getStatusesForPipelineGroup } from './pipelineConfig';
import { getNsirExportPermissions } from '../../../helpers/nsirReportAccess';
import * as selectorsModuleConfiguration from '../../../store/moduleConfiguration/reducer';
import {
  getDefaultFilter,
  getDefaultStatusParaFiltroNsirs,
  getStatusOptionsByRole,
  normalizeNsirFilterForApi,
  countNsirAdvancedFilters,
  summarizeNsirAdvancedFilters,
  resolveNsirLocalFilter,
  lockTipoServicoUsoMutuo,
  DIALOG_TYPES,
  ERROR_MESSAGES,
  EXPORT_MESSAGES,
  EXPORT_FINANCEIRO_FORMAT,
  EXPORT_FINANCEIRO_FORMAT_LABELS,
  DEFAULT_DATE_TYPES,
  DIGITADOR_DIARIO_ALLOWED_EMAILS,
  parseCargaQuery,
  hasCargaQuery,
  applyCargaQueryToFilter,
} from './constants';
import {
  countBatchEligibility,
  partitionBatchSelection,
  getBatchValidationMessage,
  getAntecipadaDigitadorSummary,
  buildAntecipadaLotes,
} from './batchEligibility';
import { applyPeriodoInspetorQuery } from '../../../helpers/periodoInspetorQuery';
import { canLiberarDigitacaoAntecipada } from '../../../helpers/digitacaoAntecipada';
import { hasModuleConfiguration } from '../../../helpers/moduleConfigurationPermission';
import { NSIR_STATUS_UPDATE } from '../../../constants/modules';
import UsuarioModal from '../Nsir/UsuarioModal';
import StatusModal from '../Nsir/StatusModal';
import LiberarDigitacaoAntecipadaLoteModal from './LiberarDigitacaoAntecipadaLoteModal';

class CardsErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) return null;
    return this.props.children;
  }
}

CardsErrorBoundary.propTypes = {
  children: PropTypes.node,
};

const dialogReducer = (state, action) => {
  switch (action.type) {
    case 'OPEN':
      return { ...state, [action.dialogType]: true };
    case 'CLOSE':
      return { ...state, [action.dialogType]: false };
    case 'CLOSE_ALL':
      return Object.keys(state).reduce((acc, key) => ({ ...acc, [key]: false }), {});
    default:
      return state;
  }
};

const initialDialogState = {
  [DIALOG_TYPES.IMPORT]: false,
  [DIALOG_TYPES.IMPORT_NSMPS]: false,
  [DIALOG_TYPES.IMPORT_FINANCEIRO]: false,
  [DIALOG_TYPES.IMPORT_DIGITADOR]: false,
  [DIALOG_TYPES.IMPORT_PREVIEW]: false,
  [DIALOG_TYPES.EXPORT]: false,
  [DIALOG_TYPES.EXPORT_EDIT]: false,
  [DIALOG_TYPES.EXPORT_SERVICO]: false,
  [DIALOG_TYPES.EXPORT_FINANCEIRO]: false,
  [DIALOG_TYPES.EXPORT_DIGITADOR]: false,
  [DIALOG_TYPES.EXPORT_INSPECAO]: false,
  [DIALOG_TYPES.EXPORT_REPORT_USO_MUTUO]: false,
  [DIALOG_TYPES.EXPORT_DIGITADOR_DIARIO]: false,
  [DIALOG_TYPES.EXPORT_PROJETO_OBRAS]: false,
};

const NsirsV2 = ({
  importNsirs,
  history,
  location,
  cleanSelectedNsir,
  userRole,
  authData,
  messageError,
  deleteNsir,
  forceUpdateStatusNsir,
  exportNsirs,
  cacheFiltroNsir,
  importNsirServices,
  exportToEditNsirs,
  exportFinanceiro,
  importNsirFinanceiro,
  nsirExport,
  defaultNsirImport,
  previewNsirImport,
  generateNsirReport,
  generateInspecaoReport,
  generateReportUsoMutuo,
  generateReportDigitadorDiario,
  startRelatorioAuditoriaFaixa,
  showLoader,
  hideLoader,
  cloneNsir,
  setCacheFiltroNsir,
  batchNsirDigitadores,
  batchNsirInspetores,
  batchDigitacaoAntecipadaNsir,
  batchForceUpdateStatusNsir,
  moduleConfigurations,
}) => {
  const [dialogs, dispatchDialog] = useReducer(dialogReducer, initialDialogState);
  const [activePipelineGroup, setActivePipelineGroup] = useState(null);
  const [activeUrgency, setActiveUrgency] = useState(null);
  const [importPreview, setImportPreview] = useState(null);
  const [importRawData, setImportRawData] = useState(null);
  const [importedFile, setImportedFile] = useState(null);
  const [openClone, setOpenClone] = useState(false);
  const [cloneId, setCloneId] = useState(null);
  const [openFilter, setOpenFilter] = useState(false);
  const [reload, setReload] = useState(false);
  const [deleteConflict, setDeleteConflict] = useState(null);
  const [exclusaoForcada, setExclusaoForcada] = useState(null);
  const [exportFinanceiroSplitTabs, setExportFinanceiroSplitTabs] = useState(false);
  const cargaQuery = useMemo(
    () => parseCargaQuery(location?.search),
    [location?.search],
  );
  const [batchMode, setBatchMode] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);
  const [digitadorModalOpen, setDigitadorModalOpen] = useState(false);
  const [inspetorModalOpen, setInspetorModalOpen] = useState(false);
  const [antecipadaModalOpen, setAntecipadaModalOpen] = useState(false);
  const [statusModalOpen, setStatusModalOpen] = useState(false);
  const [overlayFilter, setOverlayFilter] = useState(false);
  const statusByIdRef = useRef(new Map());
  const skipCargaFilterReloadRef = useRef(true);

  // Safety net: limpa loader global preso (ex.: race pós-login com module-configurations).
  useEffect(() => {
    hideLoader();
  }, [hideLoader]);

  const isAuditor = isRoleAuditoriaNsir(userRole);
  const isUsoMutuo = isUsuarioUsoMuto(authData.email);
  const isAdmin = Role.ADMIN === userRole || Role.SUPER_ADMIN === userRole;
  const hasAdd = isAdmin && !isUsoMutuo;
  const showEdit = !isUsoMutuo;
  const showView = isUsoMutuo;
  const showDelete = isAdmin && !isUsoMutuo;
  const canBatch = isAdmin && !isUsoMutuo && !isAuditor;
  const canLiberarAntecipada = canLiberarDigitacaoAntecipada({
    authData,
    moduleConfigurations,
  });
  const canForceStatusLote = canBatch && hasModuleConfiguration(
    moduleConfigurations,
    authData,
    NSIR_STATUS_UPDATE,
  );

  const persona = useMemo(
    () => resolveNsirListPersona({ authData, userRole }),
    [authData, userRole],
  );

  const optionsStatus = useMemo(
    () => getStatusOptionsByRole(userRole),
    [userRole],
  );

  const defaultFilter = useMemo(
    () => getDefaultFilter(authData.email, isUsuarioUsoMuto, userRole, authData.id),
    [authData.email, authData.id, userRole],
  );

  const [localFilter, setLocalFilter] = useState(() => {
    const query = parseCargaQuery(location?.search);
    if (hasCargaQuery(query)) {
      return applyCargaQueryToFilter(defaultFilter, query);
    }
    const fromInspetor = applyPeriodoInspetorQuery(defaultFilter, location?.search, { idKey: 'inspetorId' });
    if (fromInspetor !== defaultFilter) return fromInspetor;
    return resolveNsirLocalFilter(cacheFiltroNsir, defaultFilter, isAuditor, isUsoMutuo);
  });

  const skipCacheSyncRef = useRef(true);

  const apiFilterBase = useMemo(
    () => normalizeNsirFilterForApi(localFilter),
    [localFilter],
  );

  const apiFilter = useMemo(() => {
    const pipelineStatuses = getStatusesForPipelineGroup(persona, activePipelineGroup);
    const activeGroup = getPipelineGroupsForPersona(persona)
      .find((group) => group.key === activePipelineGroup);
    const filterWithPipeline = pipelineStatuses
      ? { ...localFilter, status: pipelineStatuses }
      : localFilter;

    const filterWithUrgency = activeUrgency
      ? { ...filterWithPipeline, vencimentoUrgency: activeUrgency }
      : filterWithPipeline;

    const applyOverlay = overlayFilter || Boolean(activeGroup?.digitacaoAntecipada);
    const filterWithOverlay = applyOverlay
      ? { ...filterWithUrgency, digitacaoAntecipada: true }
      : filterWithUrgency;

    return normalizeNsirFilterForApi(filterWithOverlay);
  }, [localFilter, persona, activePipelineGroup, activeUrgency, overlayFilter]);

  const handlePipelineGroupChange = useCallback((groupKey) => {
    setActivePipelineGroup(groupKey);
    setOverlayFilter(false);
    if (groupKey) setActiveUrgency(null);
  }, []);

  const handleOverlayFilter = useCallback(() => {
    const groups = getPipelineGroupsForPersona(persona);
    const antecipadaGroup = groups.find((group) => group.digitacaoAntecipada);
    const inspecaoGroup = groups.find((group) => group.key === 'INSPECAO');
    setActivePipelineGroup(antecipadaGroup?.key || inspecaoGroup?.key || null);
    setOverlayFilter(true);
    setActiveUrgency(null);
  }, [persona]);

  const handleUrgencyChange = useCallback((urgency) => {
    setActiveUrgency(urgency);
    if (urgency) {
      setActivePipelineGroup(null);
      setOverlayFilter(false);
    }
  }, []);

  const onFilterNsirs = useCallback(
    (filter) => {
      let payload = isAuditor
        ? mergeFiltroNsirComRestricoesAuditoria(filter)
        : filter;
      if (isUsoMutuo) payload = lockTipoServicoUsoMutuo(payload);
      setCacheFiltroNsir(payload);
      setLocalFilter(payload);
      setOpenFilter(false);
      setActivePipelineGroup(null);
      setActiveUrgency(null);
      setOverlayFilter(false);
      setReload((r) => !r);
    },
    [isAuditor, isUsoMutuo, setCacheFiltroNsir],
  );

  useEffect(() => {
    if (skipCacheSyncRef.current) {
      skipCacheSyncRef.current = false;
      return;
    }
    if (hasCargaQuery(cargaQuery)) return;

    setLocalFilter(resolveNsirLocalFilter(cacheFiltroNsir, defaultFilter, isAuditor, isUsoMutuo));
  }, [cacheFiltroNsir, defaultFilter, isAuditor, isUsoMutuo, cargaQuery.malhaId, cargaQuery.digitadorId]);

  useEffect(() => {
    if (!hasCargaQuery(cargaQuery)) return;
    const next = applyCargaQueryToFilter(defaultFilter, cargaQuery);
    setLocalFilter(next);
    setCacheFiltroNsir(next);
    setActivePipelineGroup(null);
    setActiveUrgency(null);
    if (skipCargaFilterReloadRef.current) {
      skipCargaFilterReloadRef.current = false;
      return;
    }
    setReload((r) => !r);
  }, [cargaQuery.malhaId, cargaQuery.digitadorId, defaultFilter, setCacheFiltroNsir]);

  const openDialog = useCallback((dialogType) => {
    dispatchDialog({ type: 'OPEN', dialogType });
  }, []);

  const closeDialog = useCallback((dialogType) => {
    dispatchDialog({ type: 'CLOSE', dialogType });
  }, []);

  const onEdit = useCallback((id) => {
    cleanSelectedNsir();
    history.push(`/v2/nsir/${id}`);
  }, [cleanSelectedNsir, history]);

  const onAdd = useCallback(() => {
    cleanSelectedNsir();
    history.push('/v2/nsir');
  }, [cleanSelectedNsir, history]);

  const onDelete = useCallback((id, row) => {
    deleteNsir(id, () => setReload((r) => !r), {
      onRiscoAlto: (mensagem, motivos) => setDeleteConflict({
        type: NSIR_DELETE_CONFLICT.RISCO_ALTO,
        id,
        status: row?.status,
        mensagem,
        motivos,
      }),
      onConfirmacao: (mensagem, motivos) => setDeleteConflict({
        type: NSIR_DELETE_CONFLICT.CONFIRMACAO,
        id,
        mensagem,
        motivos,
      }),
    });
  }, [deleteNsir]);

  const onCancelarNsir = useCallback(() => {
    if (!deleteConflict) return;
    const { id } = deleteConflict;
    setDeleteConflict(null);
    forceUpdateStatusNsir(id, Status.CANCELADA, () => setReload((r) => !r));
  }, [deleteConflict, forceUpdateStatusNsir]);

  const onForceDelete = useCallback(() => {
    if (!deleteConflict) return;
    const { id } = deleteConflict;
    setDeleteConflict(null);
    deleteNsir(id, () => setReload((r) => !r), { force: true });
  }, [deleteConflict, deleteNsir]);

  const onPedirExclusaoForcada = useCallback(() => {
    if (!deleteConflict) return;
    setExclusaoForcada(deleteConflict);
    setDeleteConflict(null);
  }, [deleteConflict]);

  const onExcluirDefinitivamente = useCallback(() => {
    if (!exclusaoForcada) return;
    const { id } = exclusaoForcada;
    setExclusaoForcada(null);
    deleteNsir(id, () => setReload((r) => !r), { force: true });
  }, [exclusaoForcada, deleteNsir]);

  const consequenciasExclusaoForcada = useMemo(
    () => getConsequenciasExclusao(exclusaoForcada?.motivos),
    [exclusaoForcada],
  );

  const motivosConflito = useMemo(
    () => getMotivosDescricao(deleteConflict?.motivos),
    [deleteConflict],
  );

  const avisoNsirFechada = useMemo(
    () => getAvisoNsirFechada(deleteConflict?.status),
    [deleteConflict],
  );

  const handleFileImport = useCallback(async (files, importFn, sheetName, dialogType, errorMessage) => {
    if (!files || files.length === 0) {
      messageError({ message: 'Nenhum arquivo selecionado.' });
      return;
    }

    showLoader();

    try {
      const reader = new FileReader();

      reader.onload = (e) => {
        try {
          const workbook = XLSX.read(e.target.result, { type: 'binary' });

          if (!workbook.SheetNames.includes(sheetName)) {
            messageError({ message: errorMessage });
            hideLoader();
            return;
          }

          const nsirs = [];
          const excelData = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], { header: 1 }).slice(1);

          for (const row of excelData) {
            if (row.length > 0) {
              nsirs.push(row);
            }
          }

          if (nsirs.length === 0) {
            messageError({ message: 'A planilha está vazia ou não contém dados válidos.' });
            hideLoader();
            return;
          }

          importFn({ nsirs }, () => {
            closeDialog(dialogType);
            hideLoader();
            setReload((r) => !r);
          });
        } catch (parseError) {
          console.error('Error parsing file:', parseError);
          messageError({ message: ERROR_MESSAGES.READ_ERROR });
          hideLoader();
        }
      };

      reader.onerror = () => {
        messageError({ message: ERROR_MESSAGES.READ_ERROR });
        hideLoader();
      };

      reader.readAsBinaryString(files[0]);
    } catch (error) {
      console.error('Error reading file:', error);
      messageError({ message: ERROR_MESSAGES.READ_ERROR });
      hideLoader();
    }
  }, [messageError, showLoader, hideLoader, closeDialog]);

  const onImport = useCallback((files) => {
    const selectedFile = files && files[0] ? files[0] : null;
    handleFileImport(
      files,
      (data, done) => {
        previewNsirImport(data, (preview) => {
          setImportPreview(preview);
          setImportRawData(data);
          setImportedFile(selectedFile);
          openDialog(DIALOG_TYPES.IMPORT_PREVIEW);
          done();
        });
      },
      'Nsirs',
      DIALOG_TYPES.IMPORT,
      ERROR_MESSAGES.INVALID_SHEET,
    );
  }, [handleFileImport, previewNsirImport, openDialog]);

  const onConfirmImport = useCallback((selectedLines) => {
    const normalizedSelectedLines = (selectedLines || []).filter(Number.isInteger);
    if (normalizedSelectedLines.length === 0) {
      messageError({ message: 'Selecione ao menos uma linha válida para importar.' });
      return;
    }

    if (!importPreview || !importPreview.previewToken) {
      messageError({ message: 'Token de validação expirado. Faça uma nova importação.' });
      return;
    }

    importNsirs({
      previewToken: importPreview.previewToken,
      selectedLines: normalizedSelectedLines,
    }, () => {
      closeDialog(DIALOG_TYPES.IMPORT_PREVIEW);
      setImportPreview(null);
      setImportRawData(null);
      setImportedFile(null);
      setReload((r) => !r);
    });
  }, [importNsirs, importPreview, closeDialog, messageError]);

  const onDownloadImportedFile = useCallback(() => {
    if (importedFile) {
      const downloadUrl = URL.createObjectURL(importedFile);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = importedFile.name || 'planilha-importada.xlsx';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(downloadUrl);
      return;
    }

    if (!importRawData || !Array.isArray(importRawData.nsirs) || importRawData.nsirs.length === 0) {
      messageError({ message: 'Não foi possível recuperar a planilha importada.' });
      return;
    }

    const worksheet = XLSX.utils.aoa_to_sheet(importRawData.nsirs);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Nsirs');
    XLSX.writeFile(workbook, 'planilha-importada.xlsx');
  }, [importedFile, importRawData, messageError]);

  const onNewImport = useCallback(() => {
    closeDialog(DIALOG_TYPES.IMPORT_PREVIEW);
    setImportPreview(null);
    setImportRawData(null);
    setImportedFile(null);
    openDialog(DIALOG_TYPES.IMPORT);
  }, [closeDialog, openDialog]);

  const onImportFinanceiro = useCallback((files) => {
    handleFileImport(
      files,
      importNsirFinanceiro,
      'NSIRs Financeiro',
      DIALOG_TYPES.IMPORT_FINANCEIRO,
      ERROR_MESSAGES.INVALID_SHEET,
    );
  }, [handleFileImport, importNsirFinanceiro]);

  const onImportDigitadores = useCallback((files) => {
    handleFileImport(
      files,
      (data, callback) => defaultNsirImport('import/digitadores', data, callback),
      'NSIRs Digitadores',
      DIALOG_TYPES.IMPORT_DIGITADOR,
      ERROR_MESSAGES.INVALID_DIGITADOR_SHEET,
    );
  }, [handleFileImport, defaultNsirImport]);

  const onImportNsmps = useCallback((files) => {
    if (!files || files.length === 0) {
      messageError({ message: 'Nenhum arquivo selecionado.' });
      return;
    }

    showLoader();

    const reader = new FileReader();

    reader.onload = (e) => {
      try {
        const nsirData = JSON.parse(e.target.result);

        if (!nsirData.nsir || !nsirData.nsmps || !nsirData.fotos) {
          messageError({ message: ERROR_MESSAGES.INVALID_FILE });
          hideLoader();
          return;
        }

        importNsirServices(nsirData, () => {
          closeDialog(DIALOG_TYPES.IMPORT_NSMPS);
          hideLoader();
          setReload((r) => !r);
        });
      } catch (parseError) {
        console.error('Error parsing JSON file:', parseError);
        messageError({ message: ERROR_MESSAGES.INVALID_FILE });
        hideLoader();
      }
    };

    reader.onerror = () => {
      messageError({ message: ERROR_MESSAGES.READ_ERROR });
      hideLoader();
    };

    reader.readAsText(files[0]);
  }, [messageError, showLoader, hideLoader, importNsirServices, closeDialog]);

  const onExportFinanceiro = useCallback(() => {
    exportFinanceiro(
      { ...apiFilter, splitTabs: exportFinanceiroSplitTabs },
      () => {
        closeDialog(DIALOG_TYPES.EXPORT_FINANCEIRO);
        setExportFinanceiroSplitTabs(false);
      },
    );
  }, [apiFilter, exportFinanceiroSplitTabs, exportFinanceiro, closeDialog]);

  const onCloseExportFinanceiro = useCallback(() => {
    closeDialog(DIALOG_TYPES.EXPORT_FINANCEIRO);
    setExportFinanceiroSplitTabs(false);
  }, [closeDialog]);

  const onExportServico = useCallback((apenasDigitados) => {
    generateNsirReport(
      apiFilter,
      () => closeDialog(DIALOG_TYPES.EXPORT_SERVICO),
      apenasDigitados,
    );
  }, [apiFilter, generateNsirReport, closeDialog]);

  const onExport = useCallback(() => {
    const exportHandlers = {
      [DIALOG_TYPES.EXPORT_EDIT]: () => exportToEditNsirs(apiFilter, () => closeDialog(DIALOG_TYPES.EXPORT_EDIT)),
      [DIALOG_TYPES.EXPORT]: () => exportNsirs(apiFilter, () => closeDialog(DIALOG_TYPES.EXPORT)),
      [DIALOG_TYPES.EXPORT_DIGITADOR]: () => nsirExport('export/digitadores', 'RelatórioDigitadores.xlsx', apiFilter, () => closeDialog(DIALOG_TYPES.EXPORT_DIGITADOR)),
      [DIALOG_TYPES.EXPORT_INSPECAO]: () => generateInspecaoReport(apiFilter, () => closeDialog(DIALOG_TYPES.EXPORT_INSPECAO)),
      [DIALOG_TYPES.EXPORT_REPORT_USO_MUTUO]: () => generateReportUsoMutuo(apiFilter, () => closeDialog(DIALOG_TYPES.EXPORT_REPORT_USO_MUTUO)),
      [DIALOG_TYPES.EXPORT_DIGITADOR_DIARIO]: () => generateReportDigitadorDiario({}, () => closeDialog(DIALOG_TYPES.EXPORT_DIGITADOR_DIARIO)),
      [DIALOG_TYPES.EXPORT_PROJETO_OBRAS]: () => nsirExport(
        'report/projetos-obras',
        'Relatório Projeto e Obras.xlsx',
        apiFilter,
        () => closeDialog(DIALOG_TYPES.EXPORT_PROJETO_OBRAS),
      ),
    };

    const activeDialog = Object.keys(dialogs).find(key => dialogs[key] === true);
    if (activeDialog && exportHandlers[activeDialog]) {
      exportHandlers[activeDialog]();
    }
  }, [apiFilter, dialogs, closeDialog, exportToEditNsirs, exportNsirs, nsirExport, generateInspecaoReport, generateReportUsoMutuo, generateReportDigitadorDiario]);

  const defaultTipoServico = useMemo(() => {
    if (isAuditor) {
      return getNsirFiltroFixoAuditoriaNsir().tipoServicos;
    }
    if (isUsoMutuo) {
      return [INSPECAO_USUO_MUTUO_ID];
    }
    return null;
  }, [isAuditor, isUsoMutuo]);

  const filterFields = useMemo(() => {
    const moreFields = [];

    // Linha 1: flags + prioridade (+ dig. antecipada)
    if (!isUsoMutuo) {
      moreFields.push({ field: 'usePossuiCroqui', md: 2, xs: 6 });
    }

    if (!isAuditor && !isUsoMutuo) {
      moreFields.push({ field: 'usePossuiHd', md: 2, xs: 6 });
    }

    if (!isAuditor && !isUsoMutuo) {
      moreFields.push({ field: 'useNsirPagaInspetor', md: 2, xs: 6 });
    }

    if (!isUsoMutuo) {
      moreFields.push({ field: 'usePrioridade', md: 3, xs: 6 });
    }

    moreFields.push({
      field: 'useSimNao',
      key: 'digitacaoAntecipada',
      label: 'Digitação antecipada',
      md: 3,
      xs: 6,
    });

    // Linha 2: Possui Apro + APRO + HD
    if (!isAuditor && !isUsoMutuo) {
      moreFields.push(
        { field: 'usePossuiApro', md: 2, xs: 6 },
        { field: 'useApro', md: 5, xs: 6 },
        { field: 'useHd', md: 5, xs: 6 },
      );
    }

    // Linha 3: Clientes + CT Plan + CT Exec
    if (!isUsoMutuo) {
      moreFields.push(
        { field: 'useCliente', md: 4, xs: 6 },
        { field: 'useCtPlan', md: 4, xs: 6 },
        { field: 'useCtExec', md: 4, xs: 6 },
      );
    }

    const fields = [
      { field: 'useDates', useDateTypes: true, md: 2, xs: 6 },
    ];

    if (!isUsoMutuo) {
      fields.push(
        {
          field: 'useTipoServico',
          md: 4,
          xs: 6,
          disabled: isAuditor,
        },
        { field: 'useSubTipoServico', md: 4, xs: 6 },
        { field: 'useAdere', adereMd: 2, adereMesesMd: 2 },
      );
    }

    fields.push(
      { field: 'useNsirs', label: 'Nsir', key: 'nsirIds', md: 4, xs: 12, minChars: 3, like: true },
      { field: 'useEquipamento', md: 4, xs: 6 },
    );

    if (!isUsoMutuo) {
      fields.push({ field: 'useNumNsmp', md: 4, xs: 6 });
    }

    fields.push({ field: 'useInspetor', multiSelect: true, md: 6, xs: 12 });

    if (userRole !== Role.DIGITADOR) {
      fields.push({ field: 'useDigitador', multiSelect: true, md: 6, xs: 12 });
    }

    if (!isUsoMutuo) {
      fields.push(
        { field: 'useMalha', md: 4, xs: 12, multiSelect: true },
        { field: 'useGerencia', md: 4, xs: 12, multiSelect: true },
        { field: 'usePolo', md: 4, xs: 12, multiSelect: true },
        { field: 'useSubestacao', md: 6, xs: 12, multiSelect: true },
        { field: 'useAlimentador', md: 6, xs: 12, multiSelect: true },
      );
    }

    fields.push({
      field: 'useNsirStatus',
      customStatus: optionsStatus,
      multiSelect: true,
      filterKey: 'status',
      md: 12,
      xs: 12,
    });

    if (moreFields.length > 0) {
      fields.push({
        field: 'useMoreFiltersCollapse',
        label: 'Mais filtros (avançados)',
        defaultExpanded: false,
        getActiveSummary: summarizeNsirAdvancedFilters,
        fields: moreFields,
      });
    }

    return fields;
  }, [isAuditor, isUsoMutuo, optionsStatus, userRole]);

  const advancedFilterCount = useMemo(
    () => countNsirAdvancedFilters(localFilter),
    [localFilter],
  );

  const columns = useMemo(() => [
    {
      field: 'codigo',
      headerName: 'NSIR e Equipamento',
      flex: 1.3,
      minWidth: 220,
      sortable: false,
      renderCell: ({ row }) => <EquipamentoNsirCell data={row} />,
    },
    {
      field: 'tipoServicoName',
      headerName: 'Tipo Serviço',
      flex: 1,
      minWidth: 160,
      sortable: false,
      renderCell: ({ row }) => <TipoServicoCell data={row} />,
    },
    {
      field: 'area',
      headerName: 'Área',
      width: 90,
      sortable: false,
      renderCell: ({ row }) => <AreaCell data={row} />,
    },
    {
      field: 'ctPlan',
      headerName: 'CT. Plan e Exec',
      flex: 0.9,
      minWidth: 130,
      sortable: false,
      renderCell: ({ row }) => <CtPlanExecCell data={row} />,
    },
    {
      field: 'malhaCodigo',
      headerName: 'Malha/Regional e Alimentador',
      flex: 1.1,
      minWidth: 180,
      sortable: false,
      renderCell: ({ row }) => <MalhaRegionalAlimentadorCell data={row} />,
    },
    {
      field: 'inspetor',
      headerName: 'Inspetor',
      flex: 0.9,
      minWidth: 130,
      sortable: false,
      renderCell: ({ row }) => <TextCell value={row.inspetor} />,
    },
    {
      field: 'digitador',
      headerName: 'Digitador',
      flex: 0.9,
      minWidth: 130,
      sortable: false,
      renderCell: ({ row }) => <TextCell value={row.digitador} />,
    },
    {
      field: 'statusName',
      headerName: 'Status',
      minWidth: 220,
      width: 220,
      sortable: false,
      renderCell: ({ row }) => <StatusCell data={row} />,
    },
    {
      field: 'vencimento',
      headerName: 'Datas',
      flex: 1,
      minWidth: 170,
      sortable: false,
      renderCell: ({ row }) => <DatasCell data={row} />,
    },
  ], []);

  const importMenuOptions = useMemo(() => [
    {
      title: 'NSIRs',
      onClick: () => openDialog(DIALOG_TYPES.IMPORT),
      show: isAdmin,
    },
    {
      title: 'Serviços',
      onClick: () => openDialog(DIALOG_TYPES.IMPORT_NSMPS),
      show: Role.CROQUI !== userRole && Role.DIGITADOR !== userRole,
    },
    {
      title: 'Financeiro',
      onClick: () => openDialog(DIALOG_TYPES.IMPORT_FINANCEIRO),
      show: isAdmin,
    },
    {
      title: 'Digitadores',
      onClick: () => openDialog(DIALOG_TYPES.IMPORT_DIGITADOR),
      show: isAdmin,
    },
  ], [isAdmin, userRole, openDialog]);

  const exportPermissions = useMemo(
    () => getNsirExportPermissions({
      authData,
      userRole,
      isAdmin,
    }),
    [authData, userRole, isAdmin],
  );

  const exportMenuOptions = useMemo(() => {
    if (isUsoMutuo) {
      return [
        {
          title: 'Uso Mútuo',
          onClick: () => openDialog(DIALOG_TYPES.EXPORT_REPORT_USO_MUTUO),
          show: exportPermissions.usoMutuo,
        },
      ];
    }

    return [
      { title: 'NSIRs', onClick: () => openDialog(DIALOG_TYPES.EXPORT), show: true },
      { title: 'P/ Edição', onClick: () => openDialog(DIALOG_TYPES.EXPORT_EDIT), show: exportPermissions.edit },
      { title: 'Financeiro', onClick: () => openDialog(DIALOG_TYPES.EXPORT_FINANCEIRO), show: exportPermissions.financeiro },
      { title: 'Projeto e Obras', onClick: () => openDialog(DIALOG_TYPES.EXPORT_PROJETO_OBRAS), show: exportPermissions.financeiro },
      { title: 'Digitadores', onClick: () => openDialog(DIALOG_TYPES.EXPORT_DIGITADOR), show: exportPermissions.digitador },
      { title: 'Serviços', onClick: () => openDialog(DIALOG_TYPES.EXPORT_SERVICO), show: exportPermissions.servico },
      { title: 'Inspeção', onClick: () => openDialog(DIALOG_TYPES.EXPORT_INSPECAO), show: exportPermissions.inspecao },
      { title: 'Uso Mútuo', onClick: () => openDialog(DIALOG_TYPES.EXPORT_REPORT_USO_MUTUO), show: exportPermissions.usoMutuo },
      {
        title: 'Digitadores Diário',
        onClick: () => openDialog(DIALOG_TYPES.EXPORT_DIGITADOR_DIARIO),
        show: DIGITADOR_DIARIO_ALLOWED_EMAILS.includes(authData.email),
      },
    ];
  }, [isUsoMutuo, exportPermissions, authData.email, openDialog]);

  const batchEligibility = useMemo(
    () => countBatchEligibility(selectedIds, statusByIdRef.current),
    [selectedIds],
  );

  const digitadorPartition = useMemo(
    () => partitionBatchSelection(selectedIds, statusByIdRef.current, 'digitador'),
    [selectedIds],
  );

  const inspetorPartition = useMemo(
    () => partitionBatchSelection(selectedIds, statusByIdRef.current, 'inspetor'),
    [selectedIds],
  );

  const antecipadaPartition = useMemo(
    () => partitionBatchSelection(selectedIds, statusByIdRef.current, 'antecipada'),
    [selectedIds],
  );

  const antecipadaDigitadorSummary = useMemo(
    () => getAntecipadaDigitadorSummary(
      antecipadaPartition.eligibleIds,
      statusByIdRef.current,
    ),
    [antecipadaPartition.eligibleIds, selectedIds],
  );

  const exitBatchMode = useCallback(() => {
    setBatchMode(false);
    setSelectedIds([]);
    statusByIdRef.current = new Map();
    setDigitadorModalOpen(false);
    setInspetorModalOpen(false);
    setAntecipadaModalOpen(false);
    setStatusModalOpen(false);
  }, []);

  const headerStartActions = useMemo(() => {
    if (!canBatch) return [];

    if (batchMode) {
      return [{
        key: 'batch-count',
        node: (
          <Typography variant="body2" sx={{ pr: 1 }}>
            {batchEligibility.total} selecionadas · {batchEligibility.digitador} válidas para digitador · {batchEligibility.inspetor} válidas para inspetor
            {canLiberarAntecipada ? ` · ${batchEligibility.antecipada} válidas para digitação antecipada` : ''}
            {canForceStatusLote ? ` · ${batchEligibility.total} válidas para atualizar status` : ''}
          </Typography>
        ),
      }];
    }

    return [{
      key: 'batch',
      label: 'Ação em lote',
      variant: 'outlined',
      startIcon: <PlaylistAddCheckOutlinedIcon />,
      onClick: () => setBatchMode(true),
    }];
  }, [canBatch, batchMode, batchEligibility, canLiberarAntecipada, canForceStatusLote]);

  const headerActions = useMemo(() => {
    if (batchMode && canBatch) {
      return [
        {
          key: 'batch-digitador',
          label: 'Trocar digitador',
          variant: 'contained',
          disabled: selectedIds.length === 0,
          onClick: () => setDigitadorModalOpen(true),
        },
        {
          key: 'batch-inspetor',
          label: 'Trocar inspetor',
          variant: 'contained',
          disabled: selectedIds.length === 0,
          onClick: () => setInspetorModalOpen(true),
        },
        ...(canLiberarAntecipada ? [{
          key: 'batch-antecipada',
          label: 'Liberar digitação antecipada',
          variant: 'contained',
          disabled: selectedIds.length === 0,
          onClick: () => setAntecipadaModalOpen(true),
        }] : []),
        ...(canForceStatusLote ? [{
          key: 'batch-status',
          label: 'Atualizar status',
          variant: 'contained',
          disabled: selectedIds.length === 0,
          onClick: () => setStatusModalOpen(true),
        }] : []),
        {
          key: 'batch-cancel',
          label: 'Cancelar',
          variant: 'outlined',
          onClick: exitBatchMode,
        },
      ];
    }

    const actions = [];

    if (!isAuditor && !isUsoMutuo) {
      actions.push({
        key: 'import',
        node: <ButtonMenuV2 title="Importar" options={importMenuOptions} />,
      });
    }

    actions.push({
      key: 'export',
      node: <ButtonMenuV2 title="Exportar" options={exportMenuOptions} />,
    });

    if (hasAdd) {
      actions.push({
        key: 'novo',
        label: 'Novo',
        onClick: onAdd,
        startIcon: <AddIcon />,
        variant: 'contained',
      });
    }

    return actions;
  }, [
    batchMode,
    canBatch,
    selectedIds.length,
    exitBatchMode,
    canLiberarAntecipada,
    canForceStatusLote,
    isAuditor,
    isUsoMutuo,
    importMenuOptions,
    exportMenuOptions,
    hasAdd,
    onAdd,
  ]);

  const handleRowSelectionChange = useCallback((ids, visibleSelected) => {
    (visibleSelected || []).forEach((row) => {
      if (row?.id != null) {
        statusByIdRef.current.set(row.id, {
          status: row.status,
          tipoServicoId: row.tipoServicoId,
          digitacaoAntecipada: row.digitacaoAntecipada,
          digitadorId: row.digitadorId || row.digitador?.id || null,
          digitadorNome: typeof row.digitador === 'string'
            ? row.digitador
            : (row.digitadorNome || row.digitador?.nome || null),
          digitador: row.digitador,
          codigo: row.codigo,
          equipamento: row.equipamento,
        });
      }
    });
    const selectedSet = new Set((ids || []).map(String));
    statusByIdRef.current.forEach((_, id) => {
      if (!selectedSet.has(String(id))) statusByIdRef.current.delete(id);
    });
    setSelectedIds(ids || []);
  }, []);

  const onBatchDone = useCallback(() => {
    exitBatchMode();
    setReload((r) => !r);
  }, [exitBatchMode]);

  const handleConfirmDigitadorLote = useCallback((usuarioId) => {
    const { eligibleIds } = digitadorPartition;
    setDigitadorModalOpen(false);
    if (eligibleIds.length === 0) return;
    batchNsirDigitadores(
      { nsirIds: eligibleIds, digitadorId: usuarioId },
      onBatchDone,
    );
  }, [batchNsirDigitadores, digitadorPartition, onBatchDone]);

  const handleConfirmInspetorLote = useCallback((usuarioId) => {
    const { eligibleIds } = inspetorPartition;
    setInspetorModalOpen(false);
    if (eligibleIds.length === 0) return;
    batchNsirInspetores(
      { nsirIds: eligibleIds, inspetorId: usuarioId },
      onBatchDone,
    );
  }, [batchNsirInspetores, inspetorPartition, onBatchDone]);

  const handleConfirmAntecipadaLote = useCallback(({ trocarTodos, digitadorId }) => {
    const { eligibleIds } = antecipadaPartition;
    setAntecipadaModalOpen(false);
    if (eligibleIds.length === 0) return;
    const lotes = buildAntecipadaLotes({
      eligibleIds,
      statusById: statusByIdRef.current,
      trocarTodos,
      digitadorId,
    });
    if (lotes.length === 0) return;
    batchDigitacaoAntecipadaNsir({ lotes }, onBatchDone);
  }, [batchDigitacaoAntecipadaNsir, antecipadaPartition, onBatchDone]);

  const handleConfirmStatusLote = useCallback((status) => {
    setStatusModalOpen(false);
    if (!status || selectedIds.length === 0) return;
    batchForceUpdateStatusNsir(
      { nsirIds: selectedIds, status },
      onBatchDone,
    );
  }, [batchForceUpdateStatusNsir, selectedIds, onBatchDone]);

  return (
    <Box>
      <Stack spacing={3}>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          justifyContent="space-between"
          alignItems={{ xs: 'flex-start', md: 'center' }}
          spacing={2}
          sx={{ pr: 2 }}
        >
          <Typography variant="h4">NSIRs</Typography>
          <Button
            variant="outlined"
            startIcon={<FilterListOutlinedIcon />}
            onClick={() => setOpenFilter(true)}
          >
            {advancedFilterCount > 0 ? `Filtros (${advancedFilterCount})` : 'Filtros'}
          </Button>
        </Stack>

        {batchMode && canBatch && (
          <Alert
            severity="info"
            action={(
              <Button
                color="inherit"
                size="small"
                onClick={exitBatchMode}
              >
                Sair do modo lote
              </Button>
            )}
          >
            Modo ação em lote — selecione NSIRs e troque digitador, inspetor
            {canLiberarAntecipada && canForceStatusLote
              ? ', libere digitação antecipada ou atualize o status'
              : canLiberarAntecipada
                ? ' ou libere digitação antecipada'
                : canForceStatusLote
                  ? ' ou atualize o status'
                  : ''
            }.
            Sair tira os checkboxes; o filtro da malha permanece.
          </Alert>
        )}

        <ContextBar
          authData={authData}
          userRole={userRole}
          moduleConfigurations={moduleConfigurations}
          persona={persona}
          localFilter={localFilter}
          activePipelineGroup={activePipelineGroup}
          activeUrgency={activeUrgency}
          onClearPipelineGroup={() => {
            setActivePipelineGroup(null);
            setOverlayFilter(false);
          }}
          onClearUrgency={() => setActiveUrgency(null)}
        />

        <CardsErrorBoundary>
          <ResumoSection
            apiFilter={apiFilterBase}
            persona={persona}
            activePipelineGroup={activePipelineGroup}
            onPipelineGroupChange={handlePipelineGroupChange}
            overlayFilter={overlayFilter}
            onOverlayFilter={handleOverlayFilter}
            activeUrgency={activeUrgency}
            onUrgencyChange={handleUrgencyChange}
            refreshKey={reload}
          />
        </CardsErrorBoundary>

        <TableV2
          useApi
          fetchUrl="nsirs/filter"
          paginationUrl="/v2/nsirs"
          rowHeight={82}
          getRowHeight={() => 'auto'}
          gridSx={tableV2MultilineGridSx}
          columns={columns}
          headerStartActions={headerStartActions}
          headerActions={headerActions}
          filterData={apiFilter}
          refreshKey={reload}
          enableRowSelection={batchMode && canBatch}
          rowSelectionModel={selectedIds}
          onRowSelectionModelChange={handleRowSelectionChange}
          onEdit={!batchMode && showEdit ? onEdit : undefined}
          onView={!batchMode && showView ? onEdit : undefined}
          onDelete={!batchMode && showDelete ? onDelete : undefined}
          actions={batchMode ? undefined : [
            {
              key: 'clone',
              title: 'Clonar',
              icon: <FileCopyIcon fontSize="small" />,
              show: (row) => canCloneAuditoriaFaixa(authData.id, row.tipoServicoId) && Status.canCloneAuditoriaFaixa(row.status),
              onClick: (id) => {
                setOpenClone(true);
                setCloneId(id);
              },
            },
            {
              key: 'relatorio-auditoria-faixa',
              title: 'Relatório Auditoria de Faixa',
              icon: <FileDownloadOutlinedIcon fontSize="small" />,
              show: (row) => isAdmin && isInspecaoAuditoriaFaixa(row.tipoServicoId),
              onClick: (id) => startRelatorioAuditoriaFaixa(id),
            },
          ]}
        />

        <CustomFilterV2
          variant="dialog"
          open={openFilter}
          onClose={() => setOpenFilter(false)}
          title="Filtros"
          fullWidth
          maxWidth="lg"
          defaultFilter={{
            ...defaultFilter,
            status: getDefaultStatusParaFiltroNsirs(userRole),
            dateTypes: DEFAULT_DATE_TYPES,
            tipoServicos: defaultTipoServico,
          }}
          appliedFilter={localFilter}
          fields={filterFields}
          onFilter={onFilterNsirs}
        />
      </Stack>

      <UploadDialogV2
        onClose={() => closeDialog(DIALOG_TYPES.IMPORT)}
        onSave={onImport}
        open={dialogs[DIALOG_TYPES.IMPORT]}
        acceptedFiles={['.xls', '.xlsx']}
        dialogTitle="Importar NSIRs"
      />
      <ImportValidationModal
        open={dialogs[DIALOG_TYPES.IMPORT_PREVIEW]}
        preview={importPreview}
        onCancel={() => {
          closeDialog(DIALOG_TYPES.IMPORT_PREVIEW);
          setImportPreview(null);
          setImportRawData(null);
          setImportedFile(null);
        }}
        onConfirm={onConfirmImport}
        onNewImport={onNewImport}
        importedFileName={importedFile ? importedFile.name : ''}
        onDownloadImportedFile={onDownloadImportedFile}
      />
      <UploadDialogV2
        onClose={() => closeDialog(DIALOG_TYPES.IMPORT_NSMPS)}
        onSave={onImportNsmps}
        open={dialogs[DIALOG_TYPES.IMPORT_NSMPS]}
        acceptedFiles={['.json']}
        dialogTitle="Importar Serviços"
      />
      <UploadDialogV2
        onClose={() => closeDialog(DIALOG_TYPES.IMPORT_FINANCEIRO)}
        onSave={onImportFinanceiro}
        open={dialogs[DIALOG_TYPES.IMPORT_FINANCEIRO]}
        acceptedFiles={['.xls', '.xlsx']}
        dialogTitle="Importar Financeiro"
      />
      <UploadDialogV2
        onClose={() => closeDialog(DIALOG_TYPES.IMPORT_DIGITADOR)}
        onSave={onImportDigitadores}
        open={dialogs[DIALOG_TYPES.IMPORT_DIGITADOR]}
        acceptedFiles={['.xls', '.xlsx']}
        dialogTitle="Importar Digitadores"
      />

      <DialogDefaultV2
        open={dialogs[DIALOG_TYPES.EXPORT]}
        handlerCancel={() => closeDialog(DIALOG_TYPES.EXPORT)}
        handlerConfirm={onExport}
        title="Confirmação"
        confirmMessage="Exportar"
      >
        <DialogContentText>{EXPORT_MESSAGES.NSIRS}</DialogContentText>
      </DialogDefaultV2>
      <DialogDefaultV2
        open={dialogs[DIALOG_TYPES.EXPORT_EDIT]}
        handlerCancel={() => closeDialog(DIALOG_TYPES.EXPORT_EDIT)}
        handlerConfirm={onExport}
        title="Confirmação"
        confirmMessage="Exportar"
      >
        <DialogContentText>{EXPORT_MESSAGES.EDIT}</DialogContentText>
      </DialogDefaultV2>
      <ExportServicosDialog
        open={dialogs[DIALOG_TYPES.EXPORT_SERVICO]}
        onClose={() => closeDialog(DIALOG_TYPES.EXPORT_SERVICO)}
        onConfirm={onExportServico}
        message={EXPORT_MESSAGES.SERVICO}
      />
      <DialogDefaultV2
        open={dialogs[DIALOG_TYPES.EXPORT_INSPECAO]}
        handlerCancel={() => closeDialog(DIALOG_TYPES.EXPORT_INSPECAO)}
        handlerConfirm={onExport}
        title="Confirmação"
        confirmMessage="Exportar"
      >
        <DialogContentText>{EXPORT_MESSAGES.INSPECAO}</DialogContentText>
      </DialogDefaultV2>
      <DialogDefaultV2
        open={dialogs[DIALOG_TYPES.EXPORT_FINANCEIRO]}
        handlerCancel={onCloseExportFinanceiro}
        handlerConfirm={onExportFinanceiro}
        title="Exportar Financeiro"
        confirmMessage="Exportar"
      >
        <DialogContentText>{EXPORT_MESSAGES.FINANCEIRO}</DialogContentText>
        <FormControl component="fieldset" sx={{ mt: 1 }}>
          <RadioGroup
            value={String(exportFinanceiroSplitTabs)}
            onChange={(e) => setExportFinanceiroSplitTabs(e.target.value === 'true')}
          >
            <FormControlLabel
              value={String(EXPORT_FINANCEIRO_FORMAT.SINGLE_TAB)}
              control={<Radio color="primary" />}
              label={EXPORT_FINANCEIRO_FORMAT_LABELS[EXPORT_FINANCEIRO_FORMAT.SINGLE_TAB]}
            />
            <FormControlLabel
              value={String(EXPORT_FINANCEIRO_FORMAT.SPLIT_BY_INSPETOR)}
              control={<Radio color="primary" />}
              label={EXPORT_FINANCEIRO_FORMAT_LABELS[EXPORT_FINANCEIRO_FORMAT.SPLIT_BY_INSPETOR]}
            />
          </RadioGroup>
          <Typography variant="caption" color="text.secondary" display="block" sx={{ ml: 4, mt: -0.5 }}>
            Inclui aba de resumo geral e uma aba para cada inspetor.
          </Typography>
        </FormControl>
      </DialogDefaultV2>
      <DialogDefaultV2
        open={dialogs[DIALOG_TYPES.EXPORT_DIGITADOR]}
        handlerCancel={() => closeDialog(DIALOG_TYPES.EXPORT_DIGITADOR)}
        handlerConfirm={onExport}
        title="Confirmação"
        confirmMessage="Exportar"
      >
        <DialogContentText>{EXPORT_MESSAGES.DIGITADOR}</DialogContentText>
      </DialogDefaultV2>
      <DialogDefaultV2
        open={dialogs[DIALOG_TYPES.EXPORT_REPORT_USO_MUTUO]}
        handlerCancel={() => closeDialog(DIALOG_TYPES.EXPORT_REPORT_USO_MUTUO)}
        handlerConfirm={onExport}
        title="Confirmação"
        confirmMessage="Exportar"
      >
        <DialogContentText>{EXPORT_MESSAGES.USO_MUTUO}</DialogContentText>
      </DialogDefaultV2>
      <DialogDefaultV2
        open={dialogs[DIALOG_TYPES.EXPORT_DIGITADOR_DIARIO]}
        handlerCancel={() => closeDialog(DIALOG_TYPES.EXPORT_DIGITADOR_DIARIO)}
        handlerConfirm={onExport}
        title="Confirmação"
        confirmMessage="Exportar"
      >
        <DialogContentText>{EXPORT_MESSAGES.DIGITADOR_DIARIO}</DialogContentText>
      </DialogDefaultV2>
      <DialogDefaultV2
        open={dialogs[DIALOG_TYPES.EXPORT_PROJETO_OBRAS]}
        handlerCancel={() => closeDialog(DIALOG_TYPES.EXPORT_PROJETO_OBRAS)}
        handlerConfirm={onExport}
        title="Confirmação"
        confirmMessage="Exportar"
      >
        <DialogContentText>{EXPORT_MESSAGES.PROJETO_OBRAS}</DialogContentText>
      </DialogDefaultV2>
      <DialogDefaultV2
        open={openClone}
        handlerCancel={() => { setOpenClone(false); setCloneId(null); }}
        handlerConfirm={() => {
          cloneNsir(cloneId, () => {
            setCloneId(null);
            setOpenClone(false);
            setReload((r) => !r);
          });
        }}
        title="Você tem certeza que deseja clonar o serviço?"
        confirmMessage="Clonar"
      >
        <DialogContentText>
          Ao clonar o serviço, todas as informações e fotos serão duplicadas. O novo serviço terá um novo código.
        </DialogContentText>
      </DialogDefaultV2>

      <DialogDefaultV2
        open={deleteConflict?.type === NSIR_DELETE_CONFLICT.RISCO_ALTO}
        handlerCancel={() => setDeleteConflict(null)}
        handlerConfirm={avisoNsirFechada ? onPedirExclusaoForcada : onCancelarNsir}
        title="Atenção antes de excluir"
        confirmMessage={avisoNsirFechada ? 'Deletar mesmo assim' : 'Cancelar NSIR'}
        confirmColor={avisoNsirFechada ? 'error' : 'primary'}
        confirmVariant={avisoNsirFechada ? 'contained' : 'outlined'}
        extraActions={avisoNsirFechada ? undefined : [
          {
            label: 'Deletar mesmo assim',
            onClick: onPedirExclusaoForcada,
            color: 'error',
          },
        ]}
      >
        {motivosConflito.length > 0 ? (
          <>
            <DialogContentText>
              Esta NSIR tem registros operacionais:
            </DialogContentText>
            <DialogContentText component="ul" sx={{ pl: 3, my: 1 }}>
              {motivosConflito.map((motivo) => (
                <li key={motivo}>{motivo}</li>
              ))}
            </DialogContentText>
          </>
        ) : (
          <DialogContentText>
            {deleteConflict?.mensagem || NSIR_DELETE_CONFLICT_FALLBACK[NSIR_DELETE_CONFLICT.RISCO_ALTO]}
          </DialogContentText>
        )}
        <DialogContentText>
          {avisoNsirFechada || 'O recomendado é cancelar a NSIR — isso preserva os registros e o histórico.'}
        </DialogContentText>
      </DialogDefaultV2>

      <DialogDefaultV2
        open={exclusaoForcada !== null}
        handlerCancel={() => setExclusaoForcada(null)}
        handlerConfirm={onExcluirDefinitivamente}
        title="Confirmar exclusão definitiva"
        confirmMessage="Excluir definitivamente"
        confirmColor="error"
        cancelMessage="Voltar"
      >
        <DialogContentText>
          Esta ação não poderá ser desfeita. Ao continuar:
        </DialogContentText>
        <DialogContentText component="ul" sx={{ pl: 3, my: 1 }}>
          {consequenciasExclusaoForcada.map((consequencia) => (
            <li key={consequencia}>{consequencia}</li>
          ))}
        </DialogContentText>
        <DialogContentText>
          Deseja excluir a NSIR mesmo assim?
        </DialogContentText>
      </DialogDefaultV2>

      <DialogDefaultV2
        open={deleteConflict?.type === NSIR_DELETE_CONFLICT.CONFIRMACAO}
        handlerCancel={() => setDeleteConflict(null)}
        handlerConfirm={onForceDelete}
        title="Exclusão com vínculos"
        confirmMessage="Excluir mesmo assim"
      >
        {motivosConflito.length > 0 ? (
          <>
            <DialogContentText>
              A exclusão exige confirmação porque esta NSIR:
            </DialogContentText>
            <DialogContentText component="ul" sx={{ pl: 3, my: 1 }}>
              {motivosConflito.map((motivo) => (
                <li key={motivo}>{motivo}</li>
              ))}
            </DialogContentText>
          </>
        ) : (
          <DialogContentText>
            {deleteConflict?.mensagem || NSIR_DELETE_CONFLICT_FALLBACK[NSIR_DELETE_CONFLICT.CONFIRMACAO]}
          </DialogContentText>
        )}
        <DialogContentText>
          Tem certeza que deseja deletar? Esta ação não poderá ser desfeita.
        </DialogContentText>
      </DialogDefaultV2>

      <UsuarioModal
        open={digitadorModalOpen}
        handlerCancel={() => setDigitadorModalOpen(false)}
        handlerConfirm={handleConfirmDigitadorLote}
        grupos={[Role.ADMIN, Role.DIGITADOR]}
        isDigitador
        title="Trocar Digitador"
        message={getBatchValidationMessage(digitadorPartition, 'digitador')}
        confirmDisabled={digitadorPartition.eligibleIds.length === 0}
      />
      <UsuarioModal
        open={inspetorModalOpen}
        handlerCancel={() => setInspetorModalOpen(false)}
        handlerConfirm={handleConfirmInspetorLote}
        grupos={[Role.ADMIN, Role.INSPETOR]}
        isDigitador={false}
        title="Trocar Inspetor"
        message={getBatchValidationMessage(inspetorPartition, 'inspetor')}
        confirmDisabled={inspetorPartition.eligibleIds.length === 0}
      />
      {canLiberarAntecipada && (
        <LiberarDigitacaoAntecipadaLoteModal
          open={antecipadaModalOpen}
          handlerCancel={() => setAntecipadaModalOpen(false)}
          handlerConfirm={handleConfirmAntecipadaLote}
          summary={antecipadaDigitadorSummary}
          validationMessage={getBatchValidationMessage(antecipadaPartition, 'antecipada')}
          confirmDisabled={antecipadaPartition.eligibleIds.length === 0}
        />
      )}
      {canForceStatusLote && (
        <StatusModal
          title="Atualizar Status"
          open={statusModalOpen}
          handlerCancel={() => setStatusModalOpen(false)}
          handlerConfirm={handleConfirmStatusLote}
        />
      )}
    </Box>
  );
};

NsirsV2.propTypes = {
  importNsirs: PropTypes.func.isRequired,
  cleanSelectedNsir: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  userRole: PropTypes.string.isRequired,
  authData: PropTypes.object.isRequired,
  messageError: PropTypes.func.isRequired,
  deleteNsir: PropTypes.func.isRequired,
  forceUpdateStatusNsir: PropTypes.func.isRequired,
  exportNsirs: PropTypes.func.isRequired,
  cacheFiltroNsir: PropTypes.object.isRequired,
  importNsirServices: PropTypes.func.isRequired,
  exportToEditNsirs: PropTypes.func.isRequired,
  exportFinanceiro: PropTypes.func.isRequired,
  importNsirFinanceiro: PropTypes.func.isRequired,
  nsirExport: PropTypes.func.isRequired,
  defaultNsirImport: PropTypes.func.isRequired,
  previewNsirImport: PropTypes.func.isRequired,
  generateNsirReport: PropTypes.func.isRequired,
  generateInspecaoReport: PropTypes.func.isRequired,
  generateReportUsoMutuo: PropTypes.func.isRequired,
  generateReportDigitadorDiario: PropTypes.func.isRequired,
  startRelatorioAuditoriaFaixa: PropTypes.func.isRequired,
  showLoader: PropTypes.func.isRequired,
  hideLoader: PropTypes.func.isRequired,
  cloneNsir: PropTypes.func.isRequired,
  setCacheFiltroNsir: PropTypes.func.isRequired,
  batchNsirDigitadores: PropTypes.func.isRequired,
  batchNsirInspetores: PropTypes.func.isRequired,
  batchDigitacaoAntecipadaNsir: PropTypes.func.isRequired,
  batchForceUpdateStatusNsir: PropTypes.func.isRequired,
  moduleConfigurations: PropTypes.array,
};

NsirsV2.defaultProps = {
  moduleConfigurations: [],
};

const mapStateToProps = state => ({
  userRole: selectorsAuth.getRole(state),
  authData: selectorsAuth.getAuth(state),
  cacheFiltroNsir: selectorsFiltro.getCacheFiltroNsir(state),
  moduleConfigurations: selectorsModuleConfiguration.getModuleConfigurations(state),
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      ...actionsNsirs,
      ...actionsRelatorioJob,
      ...actionsToast,
      ...actionsLoader,
      ...actionsFiltro,
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(NsirsV2));
